import { render, staticRenderFns } from "./StrokeTopLeftIcon.vue?vue&type=template&id=79914ac2&"
import script from "./StrokeTopLeftIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeTopLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports